import Transformations from 'scoreboard/imports/transform/transformations'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

const DatasetsTransformations = Transformations.extend({

	bannerKeyPrefix: 'datasets.transform.banner',

	groupBy: 'group',

	fields: function() {
		const metadata = this.model.get('dataSourceMetadata')
		let fields =  _.map(metadata?.fields, field =>
			_.extend({}, field, {
				id: field.rawColumnName,
				group: this.fieldsGroup(),
			})) ?? []
		// add "All Records" (only displays in if fields)
		fields.push({
			id: 'all-records',
			label: i18n.get('admin.import.transform.allRecords'),
			group: 'headerless',
			display: 'ifOnly'
		})
		// do not import record (only display in Then fields)
		fields.push({
			id: 'do-not-import-record',
			label: i18n.get('admin.import.transform.then.notImportingRecord'),
			group: 'headerless',
			display: 'thenOnly'
		})
		this.addRegexGroupFields(fields)
		// #32686 remove record (only display in Then fields)
		// #34246 the 'by removing the existing record' should only be available
		// if the dataset has a primary key defined
		if (!_.isNil(this.model.get('primaryKeyFieldId'))) {
			fields.push({
				id: 'remove-record',
				label: i18n.get('admin.import.transform.then.removeRecord'),
				group: 'headerless',
				display: 'thenOnly'
			})
		}
		return fields
	},

	fieldsById: function() {
		const metadata = this.model.get('dataSourceMetadata')
		let fields = this.fields()
		// #55464 key the fields by their intermediateColumnName too, because
		// for database datasets we use those columns in the transformations
		fields = _.concat(fields, _.map(metadata?.fields, field =>
			_.extend({}, field, {
				id: field.intermediateColumnName,
				group: this.fieldsGroup()
			})) ?? [])
		return _.keyBy(fields, 'id')
	},

	fieldsGroup: function() {
		return i18n.get('datasets.fields')
	},

	url: function() {
		return Transformations.prototype.url.apply(this, arguments) +
			'/transformations'
	}

})

export default DatasetsTransformations

DatasetsTransformations.__filename__ = 'datasets/edit/datasets-transformations.js'
